import React from 'react';
import Head from 'next/head';
import cn from 'classnames';
import Layout from 'components/layout';
import style from 'styles/conference2021/index.module.scss';

const IMG_PATH = 'https://devcdn.xylink.com/xylink_website_doc/images/conference/new-product-2021/';
const Index = () => {
  return (
    <Layout>
      <Head>
        <title>小鱼易连2021新品发布会</title>
      </Head>
      <section className={style.banner1}>
        <img src={`${IMG_PATH}pc/title.png`} className={style.title} alt="重塑未来" />
        <p className={style.subtitle}>小鱼易连2021新品发布会</p>
        <p className={style.time}>3月12日 14:00 线上直播</p>
        <div className={style.btnS}>
          <a className={style['watch-btn']} rel="noreferrer" href="http://xylink.cevent.com.cn/register.aspx?code=9e9fcae9e45049c0bca084c6e5615d56&amp;s=6972&amp;smid=798" target="_blank">
            点击报名
          </a>
          <a className={style['watch-btn']} rel="noreferrer" href="http://ityjt.net/XYLink0312.asp" target="_blank">
            观看回放
          </a>
        </div>
      </section>
      <section className={style.banner2}>
        <p>超越，永不止步</p>
        <p>定义，时代标准</p>
        <p>重塑，引领未来</p>
        <p>云视频现象级新品</p>
        <p>重磅来袭</p>
      </section>
      <section className={style.banner3}>
        <p>中国电子技术标准化研究院</p>
        <p>企业信息安全、政企信息化等领域</p>
        <p>多位业内顶级专家</p>
        <p>现场深度解读</p>
        <p>云视频产业现状与行业发展趋势</p>
      </section>
      <section className={cn(style.banner2, style.banner4)}>
        <p>多位云视频应用的先行者</p>
        <p>带来第一视角的洞察</p>
        <p>走进他们的故事</p>
        <p>感受云视频在政务、教育、企业等</p>
        <p>多领域的创造和改变</p>
      </section>
      <section className={style.banner5}>
        <p>你</p>
        <p>准备好了么？</p>
        <p>一起见证</p>
        <p>下一代云视频产品的诞生</p>
        <img src={`${IMG_PATH}pc/qrcode.png`} alt="" />
        <p className={cn(style.scan, 'for-pc')}>扫码关注公众号，报名观看发布会</p>
        <p className={cn(style.scan, 'for-mobile')}>
          扫码关注公众号
          <br />
          报名观看发布会
        </p>
      </section>
    </Layout>
  );
};

export default Index;
